import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AddQuizTitlesCall,
  DeleteQuizTitlesCall,
  EditQuizTitlesCall,
  GetQuizTitlesCall,
} from "../../redux/api/quizTitle.api";
import { setLang } from "../../redux/slices/generalSlice";
import { useSelector } from "react-redux";

const QuizTitles = () => {
  const [items, setItems] = useState([]);
  const [newTitle, setNewTitle] = useState("");
  const [message, setMessage] = useState("");
  const lang = useSelector((state) => state.general?.lang);
  const [type] = useState("histology");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchTitles = async () => {
    const res = await GetQuizTitlesCall({ lang, type });
    if (res?.status === 200) {
      setItems(res.data);
    }
  };

  const handleLanguageChange = (event) => {
    // setLanguage(event.target.value);
    dispatch(setLang(event.target.value));
    fetchTitles();
  };

  const handleAddQuestion = (id) => {
    navigate(`/showQuestions/${id}/${lang}`);
  };

  useEffect(() => {
    fetchTitles();
  }, []);

  const handleAddTitle = async () => {
    setTimeout(async () => {
      const res = await AddQuizTitlesCall({
        title: newTitle ?? "Please enter a title",
        lang,
        type,
      });
      if (res?.status === 201) {
        setMessage("Title added successfully!");
        setNewTitle("");
        fetchTitles();
      } else {
        setMessage(res?.message || "Failed to add title");
      }
    }, 200);
  };

  const handleEdit = async (id, newValue) => {
    const res = await EditQuizTitlesCall({ title_id: id, title: newValue, lang, type });
    if (res?.status === 200) fetchTitles();
  };
  const handleEditImage = async (id, newValue) => {
    const res = await EditQuizTitlesCall({ title_id: id, image: newValue, lang, type });
    if (res?.status === 200) fetchTitles();
  };

  const handleDeleteTitle = async (id) => {
    if (window.confirm("Are you sure you want to delete this title?")) {
      const res = await DeleteQuizTitlesCall({ title_id: id });
      if (res?.status === 200) {
        setMessage("Deleted successfully!");
        fetchTitles();
      }
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1} display="flex" justifyContent="flex-end" mb={2}>
        <Grid container spacing={2} alignItems="center">
          {/* Add Title Button on the Left */}
          <Grid item>
            <MDButton color="info" variant="contained" onClick={() => handleAddTitle()}>
              + Add Title
            </MDButton>
          </Grid>

          {/* Language Dropdown on the Right */}
          <Grid
            item
            xs
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <FormControl style={{ width: 250 }}>
              <InputLabel>Language</InputLabel>
              <Select value={lang} onChange={handleLanguageChange} style={{ height: 50 }}>
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="pt">Portugal</MenuItem>
                <MenuItem value="es">Spanish</MenuItem>
                <MenuItem value="it">Italian</MenuItem>
                <MenuItem value="ge">Germany</MenuItem>
                <MenuItem value="nl">Dutch</MenuItem>
                <MenuItem value="cn">Chines</MenuItem>
                <MenuItem value="ja">Japanese</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={1}>
        <Grid container spacing={3}>
          {items.map((t, index) => (
            <MDBox
              key={index}
              p={2}
              display="flex"
              flexDirection="column"
              alignItems="center"
              borderRadius="8px"
              style={{ marginBottom: 15, backgroundColor: "white", marginRight: 16 }}
            >
              <img
                src={t?.image}
                style={{
                  width: 100,
                  height: "auto",
                  borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
              <li style={{ display: "flex", flexDirection: "column" }} key={t.id}>
                <label
                  style={{
                    display: "block",
                    fontSize: 14,
                    marginTop: 10,
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  Title
                </label>
                <input
                  type="text"
                  defaultValue={t.title}
                  style={{ marginTop: 10, height: 35, padding: 8, borderRadius: 8 }}
                  onBlur={(e) => handleEdit(t.id, e.target.value)}
                />
                <label
                  style={{
                    display: "block",
                    fontSize: 14,
                    marginTop: 20,
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  Image
                </label>
                <input
                  type="text"
                  defaultValue={t.image}
                  style={{
                    height: 35,
                    padding: 8,
                    borderRadius: 8,
                    width: "100%",
                  }}
                  onBlur={(e) => handleEditImage(t.id, e.target.value)}
                />
              </li>
              <div style={{ gap: 10, display: "flex", flexDirection: "row" }}>
                <button
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderWidth: 0,
                    borderRadius: 6,
                    marginTop: 20,
                    padding: 8,
                  }}
                  onClick={() => handleDeleteTitle(t.id)}
                >
                  Delete
                </button>
                <button
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    borderWidth: 0,
                    borderRadius: 6,
                    marginTop: 20,
                    padding: 8,
                  }}
                  onClick={() => handleAddQuestion(t.id)}
                >
                  Add Questions
                </button>
              </div>
            </MDBox>
          ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default QuizTitles;
